import type { SchemaData } from '../schema/types'

/**
 * Id ↔ slug lookup derived from schema.json v1.23+. Stations in a
 * multi-line cluster share one slug (per
 * `[[schema-v1-23-slug-primary-line]]`), so `idBySlug` maps a slug to
 * the first encountered station id — any cluster member will do for
 * router purposes; the panel re-picks the primary-line record itself.
 */
export interface SlugIndex {
  readonly slugById: ReadonlyMap<string, string>
  readonly idBySlug: ReadonlyMap<string, string>
}

export function buildSlugIndex(schema: SchemaData): SlugIndex {
  const slugById = new Map<string, string>()
  const idBySlug = new Map<string, string>()
  for (const s of schema.stations) {
    if (s.slug === undefined) continue
    slugById.set(s.id, s.slug)
    if (!idBySlug.has(s.slug)) {
      idBySlug.set(s.slug, s.id)
    }
  }
  return { slugById, idBySlug }
}
